import MdaePieChart from "./component";
import { IPieChartOptions  } from "devextreme-react/pie-chart";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
export interface IMdaePieChartOptions extends IPieChartOptions {
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
}
export default MdaePieChart;
